module.exports = __webpack_public_path__ + "media/icons/ubezpieczenia-baner-573aeba6.png";